import {
  BaseEntityDto,
  GeneralStatusMetaTypedDtoOfUtilizationStatus,
} from "@/core/api/generated/v1";

import GeneralStatusMetaDisplay, {
  GeneralStatusMetaDisplayProps,
} from "./GeneralStatusMetaDisplay";
import { UtilizationStatusDisplay } from "./Statuses/UtilizationStatusDisplay";

interface Props {
  value: GeneralStatusMetaTypedDtoOfUtilizationStatus | undefined | null;
  subjectEntity: BaseEntityDto | undefined;
  statusDisplayProps?: Partial<GeneralStatusMetaDisplayProps>;
  onMetaUpdated: (newValue: GeneralStatusMetaTypedDtoOfUtilizationStatus) => void;
}

export default function GeneralStatusMetaDisplayOfUtilizationStatus({
  value,
  subjectEntity,
  statusDisplayProps,
  onMetaUpdated,
}: Props) {
  if (!value) {
    return null;
  }

  return (
    <GeneralStatusMetaDisplay
      value={value}
      subjectEntity={subjectEntity}
      mainContent={<UtilizationStatusDisplay status={value.statusTyped} />}
      onMetaUpdated={(newValue) => {
        onMetaUpdated({ ...value, ...newValue });
      }}
      {...statusDisplayProps}
    />
  );
}
